import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";

/**
 * Badge "X online" mostrato nella topbar.
 * Effettua heartbeat ogni 60s e legge il conteggio degli utenti staff visti negli ultimi 5min.
 */
export function OnlineStaffBadge() {
  const [count, setCount] = useState(null);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;
    const beat = () => api.post("/me/heartbeat").catch(() => {});
    const fetchOnline = async () => {
      try {
        const { data } = await api.get("/agency/online-staff");
        if (!mounted) return;
        setCount(data.count);
        setUsers(data.users || []);
      } catch { /* silent */ }
    };
    beat();
    fetchOnline();
    const id1 = setInterval(beat, 60000);
    const id2 = setInterval(fetchOnline, 60000);
    return () => { mounted = false; clearInterval(id1); clearInterval(id2); };
  }, []);

  if (count === null) return null;

  return (
    <div className="relative" data-testid="online-staff-badge">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-full bg-white/95 backdrop-blur border border-slate-200 shadow-sm px-3 py-1.5 hover:border-emerald-300 transition-colors"
        title={`${count} ${count === 1 ? "utente" : "utenti"} online`}
      >
        <span className="relative flex h-2 w-2">
          <span className={`absolute inline-flex h-full w-full rounded-full ${count > 0 ? "bg-emerald-400 animate-ping opacity-75" : "bg-slate-300"}`} />
          <span className={`relative inline-flex rounded-full h-2 w-2 ${count > 0 ? "bg-emerald-500" : "bg-slate-400"}`} />
        </span>
        <Users className="h-3.5 w-3.5 text-slate-600" />
        <span className="text-xs font-medium text-slate-700">
          <b className="tabular-nums">{count}</b> online
        </span>
      </button>
      {open && users.length > 0 && (
        <div className="absolute right-0 mt-2 w-56 rounded-md bg-white border border-slate-200 shadow-lg p-2 z-40">
          <p className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 mb-1.5 px-1">Staff online ora</p>
          {users.map((u) => (
            <div key={u.id} className="flex items-center gap-2 px-1 py-1 text-xs">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              <span className="font-medium text-slate-800 truncate">{u.name || u.email}</span>
              <span className="text-[10px] text-slate-400 ml-auto">{u.role}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
